"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _serializeJavascript = _interopRequireDefault(require("serialize-javascript"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint react/no-array-index-key: 0 */
/* eslint react/jsx-key: 0 */
/* Index keys doesn't matter because it is rendered only once on the server */

function Html({
  localeInfo,
  head,
  config = JSON.stringify({}),
  header = null,
  footer = null,
  children,
  state = JSON.stringify({}),
  resourceHints = [],
  additionalHeadResources = [],
  additionalBodyResources = [],
  newrelic = null
}) {
  const script = `
  window.__INITIAL_STATE__ = ${(0, _serializeJavascript.default)(state, {
    isJSON: true
  })};
  window.__LOCALE__ = ${(0, _serializeJavascript.default)(localeInfo, {
    isJSON: true
  })};
  window.__APP_CONFIG__ = ${(0, _serializeJavascript.default)(config, {
    isJSON: true
  })};
  window.__HEADER_CONTENT = ${header ? (0, _serializeJavascript.default)(header.content, {
    isJSON: true
  }) : '{}'};
  window.__FOOTER_CONTENT = ${footer ? (0, _serializeJavascript.default)(footer.content, {
    isJSON: true
  }) : '{}'};
  `;
  const renderAssets = resources => {
    return resources.map((r, index) => {
      const {
        as,
        async,
        content,
        defer,
        link,
        rel,
        type
      } = r;
      if (type === 'css' && link) {
        return /*#__PURE__*/_react.default.createElement("link", {
          key: index,
          rel: "stylesheet",
          type: "text/css",
          href: link
        });
      }
      if (type === 'js' && content) {
        return /*#__PURE__*/_react.default.createElement("script", {
          key: index,
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: content
          },
          defer: defer,
          async: async
        });
      }
      if (type.indexOf('font') === 0 && rel) {
        // font preloads require crossOrigin attribute
        // https://www.smashingmagazine.com/2016/02/preload-what-is-it-good-for/
        return /*#__PURE__*/_react.default.createElement("link", {
          key: index,
          rel: rel,
          as: as,
          type: type,
          href: link,
          crossOrigin: "anonymous"
        });
      }
      if (type === 'hint' && rel) {
        return /*#__PURE__*/_react.default.createElement("link", {
          key: index,
          rel: rel,
          as: as,
          href: link
        });
      }
      if (type === 'link' && rel) {
        return /*#__PURE__*/_react.default.createElement("link", {
          key: index,
          rel: rel,
          href: link
        });
      }
      return /*#__PURE__*/_react.default.createElement("script", {
        key: index,
        src: r.link,
        defer: defer,
        async: async,
        type: "text/javascript"
      });
    });
  };
  return /*#__PURE__*/_react.default.createElement("html", {
    lang: localeInfo.lang
  }, /*#__PURE__*/_react.default.createElement("head", null, /*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    httpEquiv: "X-UA-Compatible",
    content: "IE=edge,chrome=1"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0"
  }), newrelic ? /*#__PURE__*/_react.default.createElement("script", {
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: newrelic.getBrowserTimingHeader().replace(/<\/?script[^>]*>/g, '')
    }
  }) : '', head.title.toComponent(), head.meta.toComponent(), head.script && head.script.toComponent(), header && header.styleElements && header.styleElements.length > 0 && /*#__PURE__*/_react.default.createElement("style", header.styleElements[0].props), footer && footer.styleElements && footer.styleElements.length > 0 && /*#__PURE__*/_react.default.createElement("style", footer.styleElements[0].props), renderAssets(resourceHints), head.link && head.link.toComponent(), renderAssets(additionalHeadResources)), /*#__PURE__*/_react.default.createElement("body", null, header && /*#__PURE__*/_react.default.createElement("header", {
    id: "ge-header",
    dangerouslySetInnerHTML: {
      __html: header.html
    }
  }), /*#__PURE__*/_react.default.createElement("main", {
    id: "app",
    role: "main",
    style: {
      minHeight: '100%'
    },
    dangerouslySetInnerHTML: {
      __html: children
    }
  }), footer && /*#__PURE__*/_react.default.createElement("footer", {
    id: "ge-footer",
    dangerouslySetInnerHTML: {
      __html: footer.html
    }
  }), /*#__PURE__*/_react.default.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: script
    }
  }), renderAssets(additionalBodyResources)));
}
Html.propTypes = {
  head: _propTypes.default.object.isRequired,
  localeInfo: _propTypes.default.object.isRequired,
  state: _propTypes.default.string.isRequired,
  config: _propTypes.default.string.isRequired,
  header: _propTypes.default.object,
  footer: _propTypes.default.object,
  children: _propTypes.default.string.isRequired,
  resourceHints: _propTypes.default.array,
  additionalHeadResources: _propTypes.default.arrayOf(_propTypes.default.shape({
    async: _propTypes.default.oneOf(['async']),
    content: _propTypes.default.string,
    defer: _propTypes.default.oneOf(['defer']),
    link: _propTypes.default.string,
    type: _propTypes.default.oneOf(['css', 'js', 'link', 'hint']).isRequired
  })),
  additionalBodyResources: _propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.oneOf(['css', 'js', 'link', 'hint']).isRequired,
    link: _propTypes.default.string,
    content: _propTypes.default.string,
    defer: _propTypes.default.oneOf(['defer'])
  })),
  newrelic: _propTypes.default.object
};
Html.defaultProps = {
  header: null,
  footer: null,
  resourceHints: [],
  additionalHeadResources: [],
  additionalBodyResources: [],
  newrelic: null
};
var _default = Html;
exports.default = _default;